import { AiOutlineClose } from 'react-icons/ai';
import { Button, Modal } from 'antd';

import '../../FileManagerModals.scss';
import '../UploadModal/UploadModal.scss';

import { FileDragger } from '../../FileDragger';

// Shared dragger-step chrome: the fixed-size (640px) file-selection Modal
// used both by UploadModal's final step and by ReuploadModal, so the two
// flows share one look instead of diverging (ReuploadModal previously ran
// its own narrower, unstyled variant of this step).
export interface DraggerModalStepProps {
  open: boolean;
  onClose: () => void;
  headerTitle: React.ReactNode;
  requiredExtensions: string[];
  isMultiPart: boolean;
  accept: string;
  placeholderLabel: string;
  selectedFiles: FileList | File[] | null;
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onValidityChange: (canSubmit: boolean) => void;
  draggerDisabled?: boolean;
  maxBytesFor?: (file: File) => number;
  validate?: (files: File[]) => Promise<string | null>;
  errorMessage?: string;
  setErrorMessage?: (message: string) => void;
  onBack: () => void;
  backLabel?: string;
  onSubmit: () => void;
  submitLabel?: string;
  submitDisabled: boolean;
  submitLoading?: boolean;
}

export const DraggerModalStep = ({
  open,
  onClose,
  headerTitle,
  requiredExtensions,
  isMultiPart,
  accept,
  placeholderLabel,
  selectedFiles,
  handleFileChange,
  onValidityChange,
  draggerDisabled,
  maxBytesFor,
  validate,
  errorMessage,
  setErrorMessage,
  onBack,
  backLabel = 'Back',
  onSubmit,
  submitLabel = 'Add',
  submitDisabled,
  submitLoading,
}: DraggerModalStepProps) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      centered
      footer={null}
      closable={false}
      title={
        <div className="upload-file-modal-header__inner">
          <span className="upload-file-modal-header__title">{headerTitle}</span>
          <a onClick={onClose} className="files__button">
            <AiOutlineClose />
          </a>
        </div>
      }
      width={640}
      classNames={{
        mask: 'upload-modal-mask',
        header: 'upload-file-modal-header',
        content: 'upload-modal-content upload-modal-content--file-step',
      }}
    >
      <div className="upload-file">
        <FileDragger
          requiredExtensions={requiredExtensions}
          isMultiPart={isMultiPart}
          accept={accept}
          placeholderLabel={placeholderLabel}
          selectedFiles={selectedFiles}
          handleFileChange={handleFileChange}
          onValidityChange={onValidityChange}
          disabled={draggerDisabled}
          maxBytesFor={maxBytesFor}
          validate={validate}
          errorMessage={errorMessage}
          setErrorMessage={setErrorMessage}
        />

        <div className="file_button-group">
          <Button className="add-file__back-button" onClick={onBack}>
            {backLabel}
          </Button>
          <Button type="primary" className="add-file__submit-button" onClick={onSubmit} loading={submitLoading} disabled={submitDisabled}>
            {submitLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
